export default function subscribeSlim() {
	return {
		email: '',
		developments: '',
		errors: [],
		successMessage: '',

		submitForm(e) {
			e.preventDefault()

			this.errors = []

			// Validate the fields
			if (!this.developments) {
				this.errors.push('Please select a development.')
			}

			if (!this.email || !this.isValidEmail(this.email)) {
				this.errors.push('Please enter a valid email address.')
			}

			if (!this.errors.length) {
				this.errors = []

				// If validation passes, show success message
				this.successMessage = 'Your message has been sent!'
				this.clearForm()
				e.target.submit()
			}
		},

		// Clear the form after submission
		clearForm() {
			this.email = '';
			this.developments = '';
		},

		isValidEmail(email) {
			const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailPattern.test(email);
		}
	}
}
